<template>
  <v-container fluid v-if="export_modal && verifyFunction().length > 0">
    <v-card>
      <v-card-title><v-icon color="error">warning</v-icon><span>{{
        $t("common.importDialog.foundProblem")
          }}</span></v-card-title>
      <v-card-text style="padding: 5px; color: red">
        <div v-html="$t(i18nErrorString) + 
        $t('common.importDialog.exportHasErrorAddon')"></div>
        <ul v-if="verifyFunction()[0].no != null">
          <li v-for="i in verifyFunction()" :key="i.no">{{ `${i.field} (` + $t(
            'common.importDialog.exportErrorColumnNo') + ` ${i.no})` }}
          </li>
        </ul>
        <ul v-if="this.verifyFunction()[0].layerName != null">
          <li v-for="i in verifyFunction()" :key="i.layerName">{{ $t(
            'common.importDialog.exportErrorLayerName') + ` ${i.layerName}` }}
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: [
    "verifyFunction",
    "i18nErrorString",
    "export_modal",
  ]
}
</script>